module.exports = __webpack_public_path__ + "media/snapshot_sound.5862b0bb.mp3";